// extracted by mini-css-extract-plugin
module.exports = {"extendedDescription":"_56d9026"};